// extracted by mini-css-extract-plugin
export default {"countdown":"r2-z","srOnly":"s2-z"};